export default {
  headerTitle: {
    fontSize: 18,
    paddingTop: '6px',
    paddingBottom: '12px'
  },
  headerButton: {
    marginBottom: '5px'
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonGroup: {
    display: 'flex',
    displayDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '0.5em'
  },
  xeroSummaryTable: {
    height: '30rem',
    overflowY: 'scroll'
  }
}



// WEBPACK FOOTER //
// ./src/css/heading.js